export default "__VITE_ASSET__Dopl92la__"